import React from 'react';
import { Card, Typography, Grid } from '@mui/material';

export default function StationCardDivisor({divisorName}){
  return (
    <Card variant="outlined" sx={{ cursor: 'move', userSelect: 'none' }}>
        <Grid container sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
          <Grid xs={10} sx={{ alignItems: 'center', justifyContent: 'center' }}>
            <Typography textAlign={'center'}>
              {divisorName}
            </Typography>
          </Grid>
        </Grid>
    </Card>
  )
}